// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"IngredientsDosageSelect_dropdown__3ze7F","input":"IngredientsDosageSelect_input__36Z52","disabled":"IngredientsDosageSelect_disabled__1Ca52"};